<div [class.filter-has-no-matching-items]="! state?.canRefine">
    <ng-container *ngIf="control && state">
        <app-range-slider [control]="control"
                          [connect]="[false, true, false]"
                          [min]="state.range.min ?? 0"
                          [max]="state.range.max ?? 0"
                          [labelFormat]="labelFormatter"
                          [animate]="false"
                          [step]="1"
                          (valueChanges)="valueChange($event)"
        ></app-range-slider>
    </ng-container>
</div>
